import { sniff } from '@/util'
import closeWebview from './bridge/closeWebview'

// 回退上一页
const backPage = function () {
  if ( sniff.isUboxApp ) {
    closeWebview()
  } else if (sniff.isWechatMiniProgram) {
    wx.miniProgram.navigateBack({
      delta: 1,
    })
  } else {
    history.back()
  }
}

export default backPage